import React from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { Tile } from "../styled/styled";
var NoTile = function () { return (React.createElement(Tile, null,
    React.createElement(FormattedMessage, { id: "home.feed.noTile" }))); };
export default NoTile;
